import React from 'react';
import './Services.css';

const visaServices = [
  { icon: 'fa-comments',          title: 'Visa Consultation',            desc: 'Expert advice on requirements & eligibility' },
  { icon: 'fa-clipboard-check',   title: 'Eligibility Assessment',       desc: 'Detailed evaluation of your application chances' },
  { icon: 'fa-list-check',        title: 'Document Checklist',           desc: 'Complete list of required documents' },
  { icon: 'fa-pen-to-square',     title: 'Application Form Filling',     desc: 'Accurate completion of visa forms' },
  { icon: 'fa-file-lines',        title: 'Cover Letter Preparation',     desc: 'Professional letters to support your case' },
  { icon: 'fa-route',             title: 'Travel Itinerary',             desc: 'Detailed day-by-day travel plans' },
  { icon: 'fa-calendar-days',     title: 'Appointment Booking',          desc: 'Schedule visa application appointments' },
  { icon: 'fa-magnifying-glass',  title: 'Document Review',              desc: 'Thorough review before submission' },
  { icon: 'fa-triangle-exclamation', title: 'Visa Refusal Assistance',   desc: 'Support for rejected applications' },
  { icon: 'fa-rotate',            title: 'Reapplication Support',        desc: 'Complete help for reapplication process' },
];

const travelServices = [
  { icon: 'fa-passport',          title: 'eVisa Assistance',             desc: 'Full support for electronic visa applications' },
  { icon: 'fa-plane-arrival',     title: 'ETA Processing',               desc: 'Electronic Travel Authorization assistance' },
  { icon: 'fa-flag',              title: 'Malaysia MDAC',                desc: 'Digital Arrival Card preparation & submission' },
  { icon: 'fa-id-card',           title: 'Thailand TDAC',                desc: 'Digital Arrival Card guidance for Thailand' },
  { icon: 'fa-file-import',       title: 'Indonesia Arrival Declaration', desc: 'Customs & arrival card support' },
  { icon: 'fa-shield-halved',     title: 'Travel Insurance',             desc: 'Insurance recommendations & assistance' },
  { icon: 'fa-plane-departure',   title: 'Flight Reservations',          desc: 'Booking confirmation for visa applications' },
  { icon: 'fa-hotel',             title: 'Hotel Reservations',           desc: 'Accommodation proof & booking confirmation' },
];

const SvcBlock = ({ icon, catTitle, catDesc, items }) => (
  <div className="svc-block">
    <div className="svc-cat-header">
      <div className="svc-cat-icon"><i className={`fas ${icon}`}></i></div>
      <div>
        <h3>{catTitle}</h3>
        <p>{catDesc}</p>
      </div>
    </div>
    <div className="svc-grid">
      {items.map((s, i) => (
        <div className="svc-item" key={i}>
          <div className="svc-item-icon"><i className={`fas ${s.icon}`}></i></div>
          <div className="svc-item-body">
            <h4>{s.title}</h4>
            <p>{s.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default function Services() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  return (
    <section id="services" className="sec sec-alt">
      <div className="container">

        <div className="svc-intro">
          <div>
            <p className="label"><i className="fas fa-briefcase"></i> Our Services</p>
            <h2 className="sec-title">Complete Visa &<br /><span>Travel Documentation</span> Services</h2>
            <div className="rule"></div>
            <p className="sec-body">From consultation to approval — end-to-end assistance for all your travel documentation needs.</p>
          </div>
          <div className="svc-intro-right">
            <a
              href="#contact"
              className="btn btn-teal"
              onClick={e => { e.preventDefault(); go('contact'); }}
            >
              <i className="fas fa-paper-plane"></i>
              Get Started
            </a>
          </div>
        </div>

        <SvcBlock
          icon="fa-passport"
          catTitle="Visa Assistance"
          catDesc="Expert guidance throughout your visa application journey"
          items={visaServices}
        />

        <SvcBlock
          icon="fa-file-circle-check"
          catTitle="Travel Documentation"
          catDesc="Essential travel documents and support services"
          items={travelServices}
        />

      </div>
    </section>
  );
}
